'use client';

import { getClientApplicationConfig } from '@hc-frontend/core-context';
import { ConsentGate } from '@hc-frontend/features-data-consent';
import { usePathname } from 'next/navigation';
import Script from 'next/script';

import { FacebookPixel } from '../presentation/atoms/tracking-pixels/facebook-pixel';

/**
 * Global scripts loaded on all pages
 * Marketing and analytics scripts are gated by consent - only load if user accepts all cookies
 */
export function GlobalScripts() {
  const config = getClientApplicationConfig();
  const pathname = usePathname();

  if (pathname.startsWith('/widgets')) {
    return null;
  }

  return (
    <>
      <Script
        src="https://cdn.userway.org/widget.js"
        data-account="Jy1Jfc6yQm"
        strategy="afterInteractive"
      />
      <ConsentGate>
        {config.core.appEnvironment === 'prd' ? (
          <>
            <Script
              id="google-tag-manage-script"
              strategy="afterInteractive"
              dangerouslySetInnerHTML={{
                __html:
                  '!function(e,t,a,n){e[n]=e[n]||[],e[n].push({"gtm.start":(new Date).getTime(),event:"gtm.js"});e=t.getElementsByTagName(a)[0],n=t.createElement(a);n.async=!0,n.src="https://www.googletagmanager.com/gtm.js?id=GTM-5GZQ3BH",e.parentNode.insertBefore(n,e)}(window,document,"script","dataLayer");',
              }}
            />

            <FacebookPixel />

            <Script
              id="taboola-script-1248460"
              strategy="afterInteractive"
              dangerouslySetInnerHTML={{
                __html:
                  '!function(t,e,c){document.getElementById(c)||(t.async=1,t.src="//cdn.taboola.com/libtrc/unip/1248460/tfa.js",t.id=c,e.parentNode.insertBefore(t,e))}(document.createElement("script"),document.getElementsByTagName("script")[0],"tb_tfa_script");',
              }}
            />

            <img
              src="//insurance.mediaalpha.com/p/OoJ6UU-BDnAnPsqYoNTk2y983osKdQ.gif"
              width="1"
              height="1"
              alt=""
            />
          </>
        ) : null}
      </ConsentGate>
    </>
  );
}
